import * as React from "react";

import { HeroImage } from "components/shared/StorefrontWizard/HeroImage/HeroImage";
import { TabbedWizardCard } from "components/shared/StorefrontWizard/TabbedWizardCard/TabbedWizardCard";
import { WizardHeroProps } from "components/shared/StorefrontWizard/WizardHero/WizardHero";
import { LobQueryRouter } from "components/shared/StorefrontWizard/LobQueryRouter";

export interface WizardWithHeroImageProps extends WizardHeroProps {}

export const WizardWithHeroImage: React.FC<WizardWithHeroImageProps> = ({
  wizardLOBs,
  wizardFormChildren,
  trackOnChangeTab,
  context,
  heroImageFigureClassNames,
  heroImageSrc,
  isSingleLobWithTitle,
  wizardState,
  cardClass,
}) => (
  <HeroImage className={heroImageFigureClassNames} src={heroImageSrc} alt="" context={context}>
    <LobQueryRouter lobs={wizardLOBs} />

    <TabbedWizardCard
      context={context}
      wizardFormChildren={wizardFormChildren}
      wizardState={wizardState}
      wrappingClassNames="all-t-padding-twelve all-x-padding-six SimpleContainer"
      cardClassNames={cardClass}
      cardContentClassNames={`uitk-cell lobFormInCard ${isSingleLobWithTitle ? "all-t-padding-three" : ""}`}
      tabGroupClassNames="formAlignedTabs all-x-padding-six"
      wizardFormClassNames="wizardOverHeroImage all-x-padding-six"
      trackOnChangeTab={trackOnChangeTab}
    />
  </HeroImage>
);
